// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para o SnackBar de progresso - Design Simplificado */
.styles_progressCard__KirH1 {
  position: fixed;
  bottom: 20px;
  left: 20px;
  min-width: 420px;
  max-width: 420px;
  height: 80px; /* Altura fixa para evitar crescimento */
  z-index: 10000; /* Adjusted z-index */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background-color: #fff3cd;
  border: 1px solid #ff9000;
  animation: styles_slideInFromLeft__g3m11 0.3s ease-out;
  overflow: hidden; /* Evitar quebra de conteúdo */
}

@keyframes styles_slideInFromLeft__g3m11 {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Barra de progresso superior */
.styles_progressTopBar__O8m\\+x {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #ff9000;
  border-radius: 8px 8px 0 0;
}

/* Conteúdo principal */
.styles_progressContent__f0stV {
  padding: 16px;
  padding-top: 20px; /* Espaço para a barra superior */
}

/* Linha 1: Título do motor */
.styles_progressTitle__xWMAy {
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.2;
  word-wrap: break-word;
}

/* Linha 2: Status, etapas e porcentagem */
.styles_progressInfo__EKAp0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #666;
  gap: 8px;
}

.styles_progressStatus__fMY\\+D {
  font-size: 0.85rem;
  font-weight: 500;
  color: #333;
  flex: 1 1;
}

.styles_progressStep__y-RuS {
  font-size: 0.85rem;
  font-weight: 600;
  color: #ff9000;
  text-align: center;
  flex: 1 1;
}

.styles_progressPercentage__fi9Yx {
  font-size: 0.85rem;
  font-weight: 700;
  color: #ff9000;
  text-align: right;
  flex: 1 1;
}

/* Responsividade */
@media (max-width: 480px) {
  .styles_progressCard__KirH1 {
    right: 10px;
    left: 10px;
    min-width: auto;
    max-width: none;
  }

  .styles_progressInfo__EKAp0 {
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }

  .styles_progressStep__y-RuS,
  .styles_progressPercentage__fi9Yx {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SnackBarProgresso/styles.module.css"],"names":[],"mappings":"AAAA,+DAA+D;AAC/D;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY,EAAE,wCAAwC;EACtD,cAAc,EAAE,qBAAqB;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sDAAwC;EACxC,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE;IACE,WAAW;IACX,UAAU;IACV,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Estilos para o SnackBar de progresso - Design Simplificado */\n.progressCard {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  min-width: 420px;\n  max-width: 420px;\n  height: 80px; /* Altura fixa para evitar crescimento */\n  z-index: 10000; /* Adjusted z-index */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 8px;\n  background-color: #fff3cd;\n  border: 1px solid #ff9000;\n  animation: slideInFromLeft 0.3s ease-out;\n  overflow: hidden; /* Evitar quebra de conteúdo */\n}\n\n@keyframes slideInFromLeft {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Barra de progresso superior */\n.progressTopBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: #ff9000;\n  border-radius: 8px 8px 0 0;\n}\n\n/* Conteúdo principal */\n.progressContent {\n  padding: 16px;\n  padding-top: 20px; /* Espaço para a barra superior */\n}\n\n/* Linha 1: Título do motor */\n.progressTitle {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  line-height: 1.2;\n  word-wrap: break-word;\n}\n\n/* Linha 2: Status, etapas e porcentagem */\n.progressInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n  color: #666;\n  gap: 8px;\n}\n\n.progressStatus {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #333;\n  flex: 1;\n}\n\n.progressStep {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #ff9000;\n  text-align: center;\n  flex: 1;\n}\n\n.progressPercentage {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #ff9000;\n  text-align: right;\n  flex: 1;\n}\n\n/* Responsividade */\n@media (max-width: 480px) {\n  .progressCard {\n    right: 10px;\n    left: 10px;\n    min-width: auto;\n    max-width: none;\n  }\n\n  .progressInfo {\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n  }\n\n  .progressStep,\n  .progressPercentage {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressCard": `styles_progressCard__KirH1`,
	"slideInFromLeft": `styles_slideInFromLeft__g3m11`,
	"progressTopBar": `styles_progressTopBar__O8m+x`,
	"progressContent": `styles_progressContent__f0stV`,
	"progressTitle": `styles_progressTitle__xWMAy`,
	"progressInfo": `styles_progressInfo__EKAp0`,
	"progressStatus": `styles_progressStatus__fMY+D`,
	"progressStep": `styles_progressStep__y-RuS`,
	"progressPercentage": `styles_progressPercentage__fi9Yx`
};
export default ___CSS_LOADER_EXPORT___;
